import { map } from 'lodash/fp';

import { Customer } from '../../selectors/select-customer/types';
import { Prices } from '../../models/price';
import { ProductType } from '../../types/product';
import prepareProductForProductTile from '../prepare-product-for-product-tile';

const prepareProductsForProductTiles = (
  allProducts: ProductType[],
  customer: Customer,
  prices: Prices,
  useFutureEffectiveDate: boolean,
) =>
  map(
    prepareProductForProductTile({
      customer,
      frequency: customer.frequency,
      mlsAmount: undefined,
      prices,
      useFutureEffectiveDate,
    }),
    allProducts,
  );

export default prepareProductsForProductTiles;
